// extracted by mini-css-extract-plugin
export default {"calendarIcon":"free-tips_calendarIcon__7VCD+"};